var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.template,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('snackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }